import { useEffect } from "react";
import { SALESFORCE_HOST_SCRIPT_SRC } from "~/config";

type SalesforceEmbedFormProps = { html: string; styles?: string };

declare global {
  interface Window {
    sfdc_forms?: {
      init?: () => void;
      add?: (fn: Function) => void;
      fns?: Function[];
      loReady?: boolean;
    };
  }
}

function stripHostScript(html: string): string {
  return html.replace(
    /<script[^>]*src="[^"]*external-forms-host\.min\.js"[^>]*><\/script>/i,
    "",
  );
}

// You cannot pass through attributes such as async/defer/src/type/noModule because they are managed by Remix internally.
// https://v2.remix.run/docs/components/scripts/
export default function SalesforceEmbedForm({
  html,
  styles,
}: SalesforceEmbedFormProps) {
  useEffect(() => {
    // Ensure host script
    if (
      !document.querySelector(`script[src="${SALESFORCE_HOST_SCRIPT_SRC}"]`)
    ) {
      const host = document.createElement("script");
      host.src = SALESFORCE_HOST_SCRIPT_SRC;
      host.async = true;
      document.head.appendChild(host);
      console.log("[SFDC] Host script injected");
    } else {
      console.log("[SFDC] Host script already present");
    }
  }, [html]);

  return (
    <div
      className={`salesforce-embed-form col-span-full ${
        styles ? styles : "mb-10"
      }`}
      dangerouslySetInnerHTML={{ __html: stripHostScript(html) }}
    />
  );
}
